import { Component, Input, forwardRef } from '@angular/core'
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms'

@Component({
   selector: 'vc-text-input',
   templateUrl: './text-input.component.html',
   styleUrl: './text-input.component.scss',
   standalone: false,
   providers: [
      {
         provide: NG_VALUE_ACCESSOR,
         useExisting: forwardRef(() => VcTextInputComponent),
         multi: true,
      },
   ],
})
export class VcTextInputComponent implements ControlValueAccessor {
   @Input() label = ''
   @Input() placeholder = ''
   @Input() type: 'text' | 'email' | 'number' | 'password' | 'tel' = 'text'
   @Input() disabled = false
   @Input() hint = ''
   @Input() maxlength: number
   @Input() min: number
   @Input() max: number
   @Input() inputMode: string = 'text'
   @Input() pattern: string = ''
   @Input() required: boolean = false
   @Input() leftIcon?: string

   value: string = '' // internal value

   onChange = (_: any) => {}
   onTouched = () => {}

   writeValue(v: any) {
      this.value = v ?? null
   }
   registerOnChange(fn: any) {
      this.onChange = fn
   }
   registerOnTouched(fn: any) {
      this.onTouched = fn
   }
   setDisabledState(isDisabled: boolean) {
      this.disabled = isDisabled
   }

   handleInput(newValue: string): void {
      this.value = newValue
      this.onChange(newValue)
   }
}
